export default [
  {
    path: '/candidates',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "candidates-list" */ '@/views/candidates/List.vue'),
  }, {
    path: '/candidates/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "candidates-create" */ '@/views/candidates/Create.vue'),
  }, {
    path: '/candidates/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "candidates" */ '@/views/candidates/Candidate.vue'),
  }
]
